import { Modal } from "bootstrap";

// company_payroll レイアウト(給与編集ページ)は app バンドルを読まないため
// window.bootstrap が無く、Bootstrap の JS モーダルが一切動かない。旧実装は
// bootstrap-select が持ち込む jQuery + BS4 modal プラグインに依存していたが、
// jQuery 撤去 (#2428) でそれが失われた。ここで BS5 の Modal を legacy バンドルに
// 載せ、data-bs-toggle="modal" のネイティブ data-API を明示配線して復活させる。
//
// 重要: application / landing / admin レイアウトは legacy と app の両バンドルを
// 読む。app バンドル (application.js) は `import * as bootstrap` の副作用で BS5 の
// data-API(data-bs-toggle/dismiss のクリックハンドラ)を自動登録し、
// `window.bootstrap = bootstrap`(full namespace)を張る。そのページで legacy 側も
// 配線すると 1 クリックで二重発火し、開いた直後に閉じる等の不具合になる。
// したがって legacy 側の配線は「app バンドルが無いページ(= window.bootstrap が
// full namespace でない)」だけで有効化する。判定はクリック時に遅延評価する
// (legacy は app pack より先に実行されるため、bind 時点では app の有無が未確定)。

const APP_BUNDLE_LOADED = () =>
  !!(window.bootstrap && window.bootstrap.Dropdown && window.bootstrap.Tooltip);

// app バンドルが無いページ用に Modal を最小 expose する(spec の
// `window.bootstrap.Modal` シグナルも兼ねる)。app バンドルがある場合は
// そちらが full namespace で上書きする。
window.bootstrap = window.bootstrap || {};
window.bootstrap.Modal = window.bootstrap.Modal || Modal;

// BS5 の data-API は full ESM を副作用 import した時のみ自動登録される。
// named import (Modal) だけでは登録されないため、data-bs-toggle / data-bs-dismiss
// のクリックを明示的に配線する。app バンドルがあるページでは data-API が既に
// 効いているので、この配線は早期 return して二重発火を避ける。
const bindModalToggles = () => {
  document.addEventListener("click", (event) => {
    if (APP_BUNDLE_LOADED()) return;

    const toggle = event.target.closest?.('[data-bs-toggle="modal"]');
    if (toggle) {
      const selector =
        toggle.getAttribute("data-bs-target") || toggle.getAttribute("href");
      const target = selector && document.querySelector(selector);
      if (target) {
        event.preventDefault();
        Modal.getOrCreateInstance(target).show();
      }
      return;
    }

    const dismiss = event.target.closest?.('[data-bs-dismiss="modal"]');
    if (dismiss) {
      const modal = dismiss.closest(".modal");
      if (!modal) return;
      // 住民税通知モーダルはサーバ側で開いた状態(.show + 静的 .modal-backdrop)で
      // 描画され JS インスタンスを持たない。この場合は BS5 の .hide() では静的
      // backdrop が残るため、DOM を直接畳んで backdrop を除去する。
      if (Modal.getInstance(modal)) {
        Modal.getInstance(modal).hide();
      } else {
        modal.classList.remove("show");
        modal.style.display = "none";
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("modal-open");
        document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      }
    }
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindModalToggles);
} else {
  bindModalToggles();
}
